// extracted by mini-css-extract-plugin
export default {"Icon":"Icons_Icon__kPu4U","Icon--active":"Icons_Icon--active__qO8f2"};